import React, { useEffect, useRef, useState } from "react"
import play from "../../assets/images/inbox/play.svg"
import commentIcon from "../../assets/images/inbox/message-2.svg"
import { UncontrolledDropdown, DropdownMenu, DropdownToggle } from "reactstrap"
import { getMessageAttachment } from "services/quickblox"
import CommentSection from "./commentSection"
import { getInitials, renderUserProfileIcon } from "./utils"

export default function CommentBoard(props) {
  const {
    selectedChat,
    messages,
    chatCred,
    inboxSession,
    getInboxChatUsers,
    chatUsers,
    handleLoadMore,
    authUser,
  } = props
  const endOfMessagesRef = useRef(null)
  const [initialLoad, setInitialLoad] = useState(true)

  useEffect(() => {
    if (messages?.items?.length > 0) {
      getInboxChatUsers({ currentUserList: chatUsers, messages: messages.items })
    }

    if (messages?.items?.length > 0 && initialLoad) {
      endOfMessagesRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      })
    }
  }, [messages])

  const [togglerHandling, settogglerHandling] = useState(null)
  const handleCommentToggler = id => {
    const isOpening = togglerHandling !== id
    settogglerHandling(isOpening ? id : null)
  }

  const chatParticipants = selectedChat?.userList?.filter(
    x => x?.chat_credentials?.qb_id !== chatCred?.qb_id
  )

  return (
    <section className="comment-board">
      <header className="comment-board-header thumbnail-wrapper">
        {!selectedChat?.profile ? (
          <div className="board-thumbnail">
            <div className="initial-character comment-board-in">
              {getInitials(selectedChat?.title)}
            </div>
          </div>
        ) : (
          <div className="user-avatar">
            <img src={selectedChat?.profile} alt="User avatar" />
          </div>
        )}
        <div className="comment-content">
          <h4 className="d-flex justify-content-between align-items-center mb-0">
            {selectedChat?.title}
            <span className="posted-user"></span>
          </h4>
          <p className="post-description">{selectedChat?.subTitle}</p>
          {selectedChat?.userList?.length > 0 ? (
            <UncontrolledDropdown group>
              <DropdownToggle data-toggle="dropdown" tag="span">
                <p className="post-description cursor-pointer">
                  {renderUserProfileIcon(selectedChat?.userList[0])}
                  {selectedChat?.userList?.length > 1 &&
                    renderUserProfileIcon(selectedChat?.userList[1])}

                  {selectedChat?.userList?.length === 1 && (
                    <span className="members-text">member</span>
                  )}
                  {selectedChat?.userList?.length === 2 && (
                    <span className="members-text">members</span>
                  )}
                  {selectedChat?.userList.length > 2 && (
                    <>
                      <span className="plus-icon">+</span>
                      <span className="member-count">
                        {selectedChat?.userList.length - 2}
                      </span>
                      <span className="members-text">
                        {selectedChat?.userList.length > 3
                          ? " members"
                          : " member"}
                      </span>
                    </>
                  )}
                </p>
              </DropdownToggle>
              <DropdownMenu>
                <ul className="dropdown-avatar-wrapper">
                  {selectedChat?.userList.map(user => (
                    <li className="d-flex align-items-center" key={user?.id}>
                      <span className="square-avatar">
                        {user?.profile_pic?.file?.url ? (
                          <img
                            src={user?.profile_pic?.file?.url}
                            alt="User Avatar"
                            width={"50"}
                            height={"50"}
                            className="message-avatar"
                          />
                        ) : (
                          <div className="initial-character video-call-in">
                            {getInitials(
                              `${user?.first_name} ${user?.last_name}`
                            )}
                          </div>
                        )}
                      </span>
                      {`${user?.first_name} ${user?.last_name}`}
                    </li>
                  ))}
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          ) : (
            <span className="members-text">No chat participants</span>
          )}
        </div>
      </header>
      <article
        className={
          messages?.items?.length > 0
            ? "comment-board-body "
            : "comment-board-body  no-message-container"
        }
      >
        <div />
        {messages?.items?.length > 0 && messages.showLoadMore && (
          <div
            className="text-center btn w-100"
            onClick={() => {
              setInitialLoad(false)
              handleLoadMore()
            }}
          >
            Load More Messages
          </div>
        )}
        {messages?.items?.length > 0 ? (
          <>
            {messages.items.map((comment, key) => {
              let prevMssgDay, date
              let crrntMssgDay = new Date(
                comment?.created_at
              ).toLocaleDateString()
              if (key === 0)
                date = new Date(comment?.created_at).toLocaleDateString()
              else {
                prevMssgDay = new Date(
                  messages.items[key - 1]?.created_at
                ).toLocaleDateString()
                date =
                  prevMssgDay !== crrntMssgDay
                    ? new Date(comment?.created_at).toLocaleDateString()
                    : false
              }

              const commentSender = chatUsers?.find(
                user => user.chat_credentials.qb_id === comment.sender_id
              )

              const senderName =
                (commentSender?.first_name
                  ? commentSender?.first_name + " "
                  : "---") +
                (commentSender?.last_name ? commentSender.last_name : "---")
              return (
                <>
                  {date && <div className="w-100 text-center py-2">{date}</div>}
                  <section key={key} className="comment-board-list">
                    <div className="thumbnail-wrapper">
                      <div className="board-thumbnail">
                        {commentSender?.profile_pic?.file?.url ? (
                          <div className="avatar">
                            <img
                              src={commentSender?.profile_pic?.file?.url}
                              alt="Avatar"
                            />
                          </div>
                        ) : (
                          <div className="initial-character direct-messages-in me-3 rounded-circle">
                            <h4 className="m-0 p-0">
                              {getInitials(
                                `${commentSender?.first_name} + ${commentSender?.last_name}`
                              )}
                            </h4>
                          </div>
                        )}
                      </div>
                      <div className="comment-content">
                        <h4 className="d-flex justify-content-between align-items-center">
                          {comment?.sender_id === chatCred.qb_id
                            ? "Me"
                            : senderName}
                          <span className="posted-user">
                            {new Date(comment?.created_at).toLocaleString(
                              "en-GB",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              }
                            )}
                          </span>
                        </h4>
                        {comment?.attachments?.length > 0 &&
                          comment?.attachments?.map((file, i) => {
                            if (
                              file?.type === "image" ||
                              file?.type === "photo" ||
                              file?.type?.includes("image")
                            ) {
                              return (
                                <img
                                  key={i}
                                  src={
                                    file?.imageUrl
                                      ? file?.imageUrl
                                      : getMessageAttachment(
                                          file?.id,
                                          inboxSession?.token
                                        )
                                  }
                                  style={{
                                    height: "280px",
                                    maxWidth: "100%",
                                    objectFit: "fill",
                                  }}
                                  alt="Attachment"
                                  className="gallery-img pb-2"
                                />
                              )
                            }
                            if (
                              file?.type === "video" ||
                              file?.type?.includes("video")
                            ) {
                              return (
                                <video
                                  key={i}
                                  style={{ maxWidth: "25%" }}
                                  controls
                                >
                                  <source
                                    src={getMessageAttachment(
                                      file?.id,
                                      inboxSession?.token
                                    )}
                                  />
                                </video>
                              )
                            }
                          })}
                        <p className="post-description"> {comment?.message}</p>
                      </div>
                    </div>

                    <div
                      className="cb-commentIcon"
                      style={{ cursor: "pointer", marginLeft: "63px" }}
                    >
                      <img
                        className="commentsIcon"
                        src={commentIcon}
                        alt="Comment"
                        onClick={() => {
                          handleCommentToggler(comment?._id, key)
                        }}
                      />
                    </div>
                    {togglerHandling == comment?._id && (
                      <div style={{ marginLeft: "20px" }}>
                        <CommentSection
                          commentList={comment?.comments}
                          getInitials={getInitials}
                          messageId={comment?._id}
                          authUser={authUser}
                        />
                      </div>
                    )}
                  </section>
                </>
              )
            })}
          </>
        ) : (
          <div className="no-message">
            <p>
              This is the very beginning of your Comment Board history{" "}
              {chatParticipants?.length > 0 && (
                <React.Fragment>
                  with{" "}
                  <i>
                    {chatParticipants
                      ?.slice(0, 3)
                      ?.map(user => `${user?.first_name} ${user?.last_name}`)
                      ?.join(", ")}
                  </i>
                  {chatParticipants?.length > 3 &&
                    `, and ${chatParticipants?.length - 3} other users`}
                </React.Fragment>
              )}
              <i></i>
            </p>
            <p>
              You will be notified for every new message in this conversation
            </p>
          </div>
        )}
        <div ref={endOfMessagesRef} />
      </article>
    </section>
  )
}
